// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ScaleQuestionLabel {
  public title!: string;

  public onScalePoint!: number;

  public static fromDto(dto: any): ScaleQuestionLabel {
    const label: ScaleQuestionLabel = new ScaleQuestionLabel();
    label.title = dto.title;
    label.onScalePoint = dto.onScalePoint;
    return label;
  }
}
